<template>
  <b-card-text class="p-1">
    <div class="row">
      <div class="col-sm-12">
        <b-row>
          <div class="col-sm-6">
            <b-form-group
                class="mb-3"
                :label="$t('pages.settings.marketplace_settings.seller_id')"
                label-for="seller-id"
                label-cols="12"
            >
              <b-form-input
                  disabled
                  :value="region.info.selling_partner_id"
                  id="seller-id"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group
                class="mb-3"
                :label="$t('pages.settings.marketplace_settings.seller_email')"
                label-for="seller-email"
                label-cols="12"
            >
              <b-input-group>
                <b-form-input
                    v-model="sellerEmail"
                    id="seller-email"
                    :class="{'is-invalid': mailSubmitted && $v.sellerEmail.$error}"
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary"
                            :disabled="sellerEmailCopy === sellerEmail"
                            @click="handleUpdateSellerEmail"
                            style="border-radius:0 0.25em 0.25em 0 !important">
                    <i class="mdi mdi-content-save"></i>
                    {{ $t('pages.settings.marketplace_settings.update_btn') }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div
                v-if="mailSubmitted && $v.sellerEmail.$error"
                class="invalid-feedback d-flex"
            >
            <span v-if="!$v.sellerEmail.required">
                    {{ $t('pages.settings.marketplace_settings.validations.email_required') }}
            </span>
              <span v-if="!$v.sellerEmail.email">
                    {{ $t('pages.settings.marketplace_settings.validations.email_invalid') }}
            </span>
            </div>
          </div>
        </b-row>
        <hr>
        <b-table
            striped
            hover
            ref="marketplaceTable"
            show-empty
            :empty-text="$t('components.bootstrap_table.empty_text')"
            :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
            :fields="fields"
            :items="region.data"
            :stacked="$store.state.app.isMobile"
        >
          <template v-slot:cell(marketplace_id)="data">
            <market-place-chip :marketPlaceId="data.item.marketplace_id"></market-place-chip>
          </template>

          <template v-slot:cell(status)="data">
            <div v-if="data.item.stage === 'processing'">
              <b-spinner class="mx-1" small></b-spinner>
              <span class="text-muted">
                       {{ $t('pages.settings.marketplace_settings.processing') }}
                 </span>
            </div>
            <h5 v-else>
                  <span class="badge" :class="{
              'badge-soft-success' : data.item.status,
              'badge-soft-danger' : !data.item.status,
            }">
              {{
                      data.item.status
                          ? $t('pages.settings.marketplace_settings.connected')
                          : $t('pages.settings.marketplace_settings.not_connected')
                    }}
            </span>
            </h5>
          </template>

          <template v-slot:cell(has_suspended_listings)="data">
            <h5>
               <span class="badge" :class="{
              'badge-soft-danger' : data.item.has_suspended_listings,
              'badge-soft-success' : !data.item.has_suspended_listings,
            }">
               {{
                   data.item.has_suspended_listings
                       ? $t('pages.settings.marketplace_settings.badges.yes')
                       : $t('pages.settings.marketplace_settings.badges.no')
                 }}
            </span>
            </h5>
          </template>

          <template v-slot:cell(action)="data">
            <b-btn @click="updateMarketplaceStatus(data.item.id, data.item)"
                   :variant="data.item.status ? 'danger' : 'success'" size="sm"
                   :disabled="data.item.stage === 'processing'">
              {{
                data.item.status
                    ? $t('pages.settings.marketplace_settings.disconnect_marketplace')
                    : $t('pages.settings.marketplace_settings.connect_marketplace')
              }}
            </b-btn>
          </template>

        </b-table>

        <div>
          <div>
            {{ $t('pages.settings.marketplace_settings.dont_see_text') }}
          </div>
          <b-btn @click="updateMarketplaceList" class="p-0" variant="link">
            {{ $t('pages.settings.marketplace_settings.dont_see_btn') }}
          </b-btn>
        </div>

      </div>
    </div>
  </b-card-text>
</template>

<script>
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";
import UserMarketPlaceService from "../../../Services/Api/UserMarketPlaceService";
import Swal from "sweetalert2";
import {email, required} from "vuelidate/lib/validators";
import QuotaAlert from "../../../mixins/QuotaAlert";

export default {
  name: "MarketPlaceSettingsDetail",
  components: {MarketPlaceChip},
  mixins: [QuotaAlert],
  props: {
    region: {
      default: null,
      type: Object,
    }
  },
  validations: {
    sellerEmail: {
      email,
      required
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'marketplace_id',
          sortable: false,
          label: this.$t('pages.settings.marketplace_settings.fields.marketplace')
        },
        {
          key: 'has_suspended_listings',
          sortable: false,
          label: this.$t('pages.settings.marketplace_settings.fields.suspended'),
          class: 'text-center'
        },
        {
          key: 'status',
          sortable: false,
          label: this.$t('pages.settings.marketplace_settings.fields.status'),
          class: 'text-center'
        },
        {
          key: 'created_at',
          sortable: false,
          label: this.$t('pages.settings.marketplace_settings.fields.created_at')
        },
        {
          key: 'action',
          sortable: false,
          label: this.$t('pages.settings.marketplace_settings.fields.action')
        }
      ],
      businessEmail: '',
      selectedMarketplace: {},
      sellerEmail: '',
      sellerEmailCopy: '',
      mailSubmitted: false
    }
  },
  methods: {
    async updateMarketplaceStatus(id, item) {
      const title = !item.status
          ? this.$t('pages.settings.marketplace_settings.enable_message')
          : this.$t('pages.settings.marketplace_settings.disable_message')
      const icon = !item.status ? 'success' : 'warning'
      Swal.fire({
        title: title,
        icon: icon,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t('pages.settings.marketplace_settings.status_confirm')
      }).then(result => {
        if (result.value) {
          UserMarketPlaceService.updateMarketplaceStatus({
            id: id,
            payload: {status: !item.status}
          }).then(() => {
            this.$emit('updateStatus', {id, status: !item.status, region: this.region.value})
            this.$auth.fetch()
          }).catch(e => {
            if (e.status === 402) {
              this.showQuotaError()
            }
          })
        }
      });
    },
    handleUpdateSellerEmail() {
      this.mailSubmitted = true
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      } else {
        const payload = {
          id: this.region.info.id,
          payload: {seller_email: this.sellerEmail}
        }
        this.sellerEmailCopy = this.sellerEmail
        this.$emit('sellerEmailUpdated', payload)
      }
    },
    updateMarketplaceList() {
      this.$emit('updateList', {region_id: this.region.info.id})
    }
  },
  created() {
    this.sellerEmail = this.region.info.seller_email
    this.sellerEmailCopy = this.region.info.seller_email
  }
}
</script>

<style scoped>

</style>